<template>
  <div class="loading-container" v-loading="true"></div>
</template>

<script>
import { loginShop } from "../../api/wap/vietin";
import { decodeToken } from "@/utils/auth";
import jwt from "jsonwebtoken";

export default {
  created() {
    let token = this.$router?.history?.current?.query?.token || "";
    console.log("token......", token);
    let user = jwt.decode(token);
    console.log("user......", user);
    loginShop({
      uid: user.vga,
      cif: user.cif,
      phone: user.phone,
      lang: localStorage.getItem("language")
    }).then(res => {
      if (res.error_code === 0) {
        window.location.href = res.data.url;
      } else {
        // if (res.error_msg.includes("Bạn vừa lấy mã xác nhận"))
        //   this.$message.error(res.error_msg);
        // else window.location.href = "/404";
        this.$message.error(res.error_msg);
      }
    });
  }
};
</script>
<style scoped>
.loading-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
</style>
